import React, { useEffect, useState } from "react";
import Loader from "../../components/UI/loader";
import ErrorMessage from "../../components/errorMessage";
import { BOOK, BOOKS, FIREBASE_DB_URL } from "../../utils/constants";
import { withRouter, Redirect } from 'react-router-dom';
import ItemDetailsView from "../../components/itemDetailsView";
import withGoTService from '../../hoc/withGoTService';
import { string, node, object, oneOfType, array, element } from 'prop-types';
import axios from 'axios';

const Field = ({ item, field, label }) => {
  return (
    <li className="list-group-item d-flex justify-content-between">
      <span className="term">{label}</span>
      <span>{item[field]}</span>
    </li>
  )
}

export { Field }

const ItemDetails = ({ itemId, itemType, children, history, gotService }) => {
  const [item, setItem] = useState(null)
  const [error, setErrorStatus] = useState(false)
  const [loading, setLoadingStatus] = useState(false)
  const [imgUrl, setImgUrl] = useState('')

  const onError = () => {
    setErrorStatus(true)
    setLoadingStatus(false)
  }

  const updateItem = () => {
    if (!itemId) {
      return
    }

    //preventing errors for internal routing for a Books page
    if (itemType === BOOKS && (itemId > 12 || isNaN(itemId))) {
      history.push(`/${BOOKS}/`)
      return <Redirect to={`/${BOOKS}/`} />
    }
    gotService.getItem(itemType, itemId)
      .then(setLoadingStatus(true))
      .then(data => {
        setLoadingStatus(false)
        setItem(data)
        if (itemType === BOOKS) {
          axios.get(`${FIREBASE_DB_URL}/${BOOKS}.json`)
            .then(res => res.data.find(({ name }) => name === data.name)['url'])
            .then(res => setImgUrl(res))
        }
      })
      .catch(onError)
  }

  useEffect(() => {
    updateItem()
    // eslint-disable-next-line 
  }, [itemId])

  const extractItemName = item => {
    return item.match(itemType)[0].substring(0, item.length - 1)
  }
  
  if (error) {
    return <ErrorMessage />
  }
  if (loading) {
    return <Loader />
  }
  if (itemType === BOOKS && itemId > 12) {
    return false
  }

  if (!item && extractItemName(itemType) === BOOK) {
    return <Loader />
  } else if (!item) {
    return <span className='select-default'>{`Please select a ${extractItemName(itemType)} from the list on the left`}</span>
  }

  const { name } = item

  return (
    <ItemDetailsView
      item={item}
      name={name}
      imgUrl={imgUrl}
      itemType={itemType}
      children={children}
      extractItemName={extractItemName}
    />
  )
}

ItemDetails.propTypes = {
  itemType: string,
  itemId: string,
  gotService: object,
  children: oneOfType([array, element, node]),
}

ItemDetails.defaultProps = {
  itemType: '',
  itemId: '',
  gotService: {},
  children: null,
}

export default withGoTService()(withRouter(ItemDetails))